import React, { Component } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import {
  Container,
  // Input, 
  // Button 
} from 'reactstrap'

import {
  // AppAside,
  AppBreadcrumb,
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarMinimizer,
  AppSidebarNav,
  // AppNavbarBrand
} from '@coreui/react'

import Header from './Header'
import Footer from './Footer'
import navigation from './_nav'
import routes from '../../routes'
import './Astra.css'
// import { timingSafeEqual } from 'crypto';
import Helper from '../../services/Helper';
import DuendeAuthGuard from '../../Components/DuendeAuthGuard';

class AstraLayout extends Component {
  state = {
    user: {}
  }

  setUser(user) {
    this.setState({
      user
    })
  }
  componentWillMount() {
    let user = Helper.verifikasiToken()
  }
  componentDidMount() {
    let user = Helper.verifikasiToken()

    if (user.roleId == 3) {
      Helper.verifikasiPimpinan()
    } // untuk manager
    this.setUser(user)

    let elMain = document.getElementsByClassName('main')
    elMain[0].style.minHeight = '100vh'
  }

  componentWillUnmount() {
  }

  render() {
    return (
      <DuendeAuthGuard>
        <div className="app">
          <AppHeader className="app-header__esr" fixed>

            <Header username={this.state.user.username} />
          </AppHeader>
          <div className="app-body">
            <AppSidebar fixed display="lg">
              <AppSidebarHeader />
              <AppSidebarForm />

              <AppSidebarNav className="mt-3" navConfig={navigation()} {...this.props} />
              <AppSidebarFooter />
            </AppSidebar>
          </div>
          <main className="main">
            <AppBreadcrumb appRoutes={routes} />
            <Container fluid>
              <Switch>
                {routes.map((route, idx) => {
                  return route.component ? (
                    <Route
                      key={idx}
                      user={this.state.user}
                      path={route.path}
                      exact={route.exact}
                      name={route.name}
                      render={props => (
                        <route.component {...props} />
                      )}
                    />)
                    : (null);
                },
                )}
                <Redirect from="/" to="/home" />
              </Switch>

            </Container>
          </main>

          <div>
            <AppFooter>
              <Container fluid>
                <div
                  style={{ height: '100px' }}
                >
                  {/*  */}
                </div>
              </Container>
            </AppFooter>
          </div>

        </div>
      </DuendeAuthGuard>
    )
  }
}

class ProfileSideBar extends Component {
  render() {
    return (
      <div>
        <div className="user-profile__sidebar hide-menu brand-minimized">
          <div className="media">
            <div className="mr-2">
              <img src="https://esrdips.com/assets/uploader/user/0xmr-1533088948-picture-1-.png" alt="user-img" height="50px" />
            </div>
            <div className="media-body text-left">
              <h5 className="media-heading mb-0">Admin ESR DIPS</h5>
              <small>Administrator</small>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AstraLayout;
